
import React from 'react';
import { cn } from '@/lib/utils';

type VideoEditorLayoutProps = {
  children: React.ReactNode;
};

export function VideoEditorLayout({ children }: VideoEditorLayoutProps) {
  return (
    // h-screen (e não min-h-screen): o editor filho usa h-full, que precisa de
    // uma altura definida no pai. O overflow-hidden já travava o crescimento.
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {children}
    </div>
  );
}
